export enum EmployeeAbsenceType {
  Vacations = 'Vacations',
  Doctor = 'Doctor',
  Other = 'Other',
}

export enum EmployeeAbsenceStatus {
  Approved = 'Approved',
  Declined = 'Declined',
  Pending = 'Pending',
}
